import React from 'react';
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap';

import { AgentTable } from './AgentTable';

const Agents = () => {
    document.title = 'Agents | MySpy';

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader>
                                    <h5 className="card-title mb-0">Agents</h5>
                                </CardHeader>
                                <CardBody className="pt-2">
                                    <AgentTable />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default Agents;
